import React, { Dispatch } from 'react';
import Translator from '../../../../../core/i18n';
import { Log } from 'ng2-logger';
import { Common } from '../../../../../core/common';
import { IAppState, IAction } from '../../../../../models/action/core';
import { connect } from 'react-redux';
import { IChoiceProps, IUserResponses } from '../../../../../models/components/activity-card-survey';

const T = Translator.create();
const _logger = Log.create('Survey Choice');
let _common: Common;

interface IChoiceState {
    selectedIds: string[];
}

class Choice extends React.Component<IChoiceProps, IChoiceState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

    }

    public state: IChoiceState = {
        selectedIds: []
    };

    setDefaultValues = () => {
        const userResponses = this.props.formik!.values.userResponses;
        const _selectedIds = this.state.selectedIds;
        userResponses.filter(r => r.surveyQuestionId === this.props.question.surveyQuestionId).forEach(element => {
            _selectedIds.push(element.surveyQuestionChoiceId);
        });
        this.setState({ selectedIds: _selectedIds });
    }

    componentDidMount() {
        this.setDefaultValues();
    }

    onChoose = (surveyQuestionChoiceId: string) => {
        const userResponses = this.props.formik!.values.userResponses;
        let response: IUserResponses | undefined;
        let responseIndex = -1;

        if (this.props.isMulti) {
            responseIndex = userResponses.findIndex(
                (_response: IUserResponses) => _response.surveyQuestionChoiceId === surveyQuestionChoiceId
            );

            if (responseIndex !== -1) {
                response = userResponses.find((_response: any) => _response.surveyQuestionChoiceId === surveyQuestionChoiceId);
            }

            const _selectedIds = this.state.selectedIds;
            const _index = _selectedIds.findIndex(s => s === surveyQuestionChoiceId);

            if (_index === -1) {
                _selectedIds.push(surveyQuestionChoiceId);
                this.setState({ selectedIds: _selectedIds });
            } else {
                _selectedIds.splice(_index, 1);
                this.setState({ selectedIds: _selectedIds });
            }
        } else {
            responseIndex = userResponses.findIndex(
                (_response: IUserResponses) => _response.surveyQuestionId === this.props.question.surveyQuestionId
            );

            if (responseIndex !== -1) {
                response = userResponses.find((_response: IUserResponses) => _response.surveyQuestionId === this.props.question.surveyQuestionId);
            }

            this.setState({ selectedIds: [surveyQuestionChoiceId] });
        }

        if (response && responseIndex !== -1) {
            response.surveyQuestionChoiceId = surveyQuestionChoiceId;
            userResponses.splice(responseIndex, 1);

            if (!this.props.isMulti) {
                userResponses.push(response);
            }
        } else {
            response = { surveyQuestionId: this.props.question.surveyQuestionId, surveyQuestionChoiceId };
            userResponses.push(response);
        }

        this.props.formik!.setFieldValue('userResponses', userResponses);
    };

    renderCardChoiceBody = (choice: any, index: any) => {
        return (
            <button key={choice.surveyQuestionChoiceId}
                className={
                    this.state.selectedIds.findIndex(s => s === choice.surveyQuestionChoiceId) !== -1
                        ? 'survey-answer selected-answer'
                        : 'survey-answer'
                }
                style={{
                    width: '100%', cursor: 'pointer', background: this.state.selectedIds.findIndex(s => s === choice.surveyQuestionChoiceId) !== -1
                        ? '#e8ebf1'
                        : 'none', textAlign: 'left'
                }}
                onClick={this.onChoose.bind(this, choice.surveyQuestionChoiceId)}
            >

            <div className="radio" style={{float: "inline-start"}}>
                   <div className='checkround-div'> {choice.text}</div>
                   <div >  <input
                        checked={
                            this.state.selectedIds.findIndex(s => s === choice.surveyQuestionChoiceId) !== -1
                        }
                        type="radio"
                        name={
                            this.props.isMulti
                                ? this.props.question.surveyQuestionId + ' ' + index.toString()
                                : this.props.question.surveyQuestionId
                        }
                        onChange={this.onChoose.bind(this, choice.surveyQuestionChoiceId)}
                    />
                    <span className={this.props.isMulti ? 'checkboxround' : 'checkround'} />
                    </div>
                </div>
            </button>
        )
    }

    renderChoiceBody = (choice: any, index: any) => {
        return (
            <div key={choice.surveyQuestionChoiceId} className="col-md-2 col-12">
                <button
                    style={{
                        cursor: 'pointer', border: this.state.selectedIds.findIndex(s => s === choice.surveyQuestionChoiceId) !== -1
                            ? ''
                            : 'none', textAlign: 'left'
                    }}
                    className={
                        this.state.selectedIds.findIndex(s => s === choice.surveyQuestionChoiceId) !== -1
                            ? 'ml-0 control-group survey_choose choosed'
                            : 'ml-0 control-group survey_choose'
                    }
                    onClick={this.onChoose.bind(this, choice.surveyQuestionChoiceId)}
                >
                    <span className={this.props.isMulti ? 'control control--checkbox' : 'control control--radio'}>

                        <span>{choice.text}</span>
                        <input
                            checked={
                                this.state.selectedIds.findIndex(s => s === choice.surveyQuestionChoiceId) !== -1
                            }
                            type="radio"
                            name={
                                this.props.isMulti
                                    ? this.props.question.surveyQuestionId + ' ' + index.toString()
                                    : this.props.question.surveyQuestionId
                            }
                            onChange={this.onChoose.bind(this, choice.surveyQuestionChoiceId)}
                        />
                        <div className="control__indicator" />
                    </span>
                </button>
            </div>
        )
    }

    public render() {
        return (
            <div className="w-100 pr-3 card-q" key={this.props.key}>
                <div className="survey_question">
                    <div>{this.props.question.description}</div>
                    <input
                        hidden
                        type="text"
                        className={this.props.isCard ? 'survey-question' : 'survey_input'}
                        disabled={true}
                        value={this.props.question.description}
                        id="survey_question_input"
                        style={{ border: 'none', paddingLeft: '0px !important' }}
                    />
                    {this.props.isCard ? (
                        <hr className="bottom-border-2 mx-0" />
                    ) : ''}
                </div>
                <div className="row" style={this.props.isCard ? { padding: 15, marginTop: '1em' } : { marginTop: '1em' }}>
                    {this.props.question.questionChoices && this.props.question.questionChoices.length > 0
                        ? this.props.question.questionChoices
                            .sort((a, b) => a.displayOrder - b.displayOrder)
                            .map((choice, index) => (
                                this.props.isCard ? this.renderCardChoiceBody(choice, index) : this.renderChoiceBody(choice, index)
                            ))
                        : ''}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IChoiceProps): IChoiceProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IChoiceProps = Object.assign({}, ownProps, {
        surveyChoices: state.coursePage.surveyChoices
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.coursePage.surveyChoices === prev.coursePage.surveyChoices;
    return ret;
};

const CChoice = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(Choice);

export default CChoice;
